@if (activeEditCategory) {
  <div class="-mx-3" data-testid="edit-category-container">
    <charge-category-create
      [activeCategory]="activeEditCategory"
      (changed)="changedEditCategory($event)"
      (close)="activeEditCategory = null"
    />
  </div>
}

<div
  [ngClass]="{ hidden: activeEditCategory }"
  data-testid="charge-category-container"
>
  <div
    class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300 -m-3"
    [ngClass]="{ hidden: activeEditCategory }"
    data-testid="charge-category-header"
  >
    <div
      class="flex align-items-center"
      [ngClass]="{ hidden: activeEditCategory }"
      data-testid="header-title-container"
    >
      <i class="fa fa-cog mr-2 text-600"></i>
      <h2 class="mb-0 text-sm" data-testid="charge-category-title">
        {{ 'ADMIN.CHARGE.MANAGE_CHARGE_CATEGORY' | translate }}
      </h2>
    </div>
    <div
      class="fa fa-times text-xl text-600 cursor-pointer"
      (click)="closeDialog()"
      aria-label="close-charge-category-dialog-button"
      data-testid="close-charge-category-dialog-button"
    ></div>
  </div>
  <!-- Header -->

  <!-- Content -->
  <div
    [ngClass]="{ hidden: activeEditCategory }"
    class="text-sm -mx-3 mt-3 -mb-3"
    data-testid="charge-category-content"
  >
    <div class="border-round" data-testid="charge-category-table-container">
      <div
        class="p-3 text-sm border-bottom-1 border-300"
        data-testid="charge-category-total"
      >
        {{ 'ADMIN.COMMON.TOTAL' | translate }} -
        <strong>{{ tableData.getValue().length }}</strong>
        {{ 'ADMIN.CHARGE.CHARGE_CATEGORY' | translate }}
      </div>

      @if (loading | async) {
        <div class="p-field p-col-12 p-md-6" data-testid="loading-skeleton">
          <p-table [value]="[0, 1, 2, 3, 4, 5, 6]">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
                <th>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-items>
              <tr>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
                <td>
                  <p-skeleton animation="wave" width="100%" height="2rem" />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }

      <app-data-grid
        [hidden]="loading | async"
        [columnData]="tableData"
        [columns]="columns"
        [totalRecords]="totalRecordLength"
        [paginator]="false"
        [EmptyState]="emptyStateComponent$"
        [selectable]="selectAllAppCatData"
        (onAction)="onActionEvent($event)"
        data-testid="charge-category-grid"
        [gridName]="'charge-category-list'"
      />
    </div>
  </div>
</div>
